import { motion } from 'framer-motion'

// Utils
import { useWindowSize } from 'hooks/usewindowsize'
import { pageVariants } from 'components/interestform/utils'

import commonStyles from 'components/interestform/slides/common.css'
import styles from './artists.css'

const Artists = (): JSX.Element => {
  const { width = 0 } = useWindowSize()

  return (
    <motion.div className={commonStyles.wrapper} initial="initial" animate="in" exit="out" variants={pageVariants}>
      <h1 className={styles.heading}>Artists with tracks using samples licensed from Tracklib</h1>
      <div className={styles.artistsImageWrapper}>
        {width > 767 ? (
          <img src="/static/images/interestform/artists-table.jpg" alt="Artists list" />
        ) : (
          <img src="/static/images/interestform/artists-table-mobile.png" alt="Artists list" />
        )}
      </div>
    </motion.div>
  )
}

export default Artists
